import { AgentGroupingType } from './agent-grouping.type';
import { OFFICE, ProfileType, TEAM } from './profile.type';

export function mapAgentGroupingTypeToProfileType(type: AgentGroupingType | undefined): Exclude<ProfileType, 'Individual'> {
  switch (type) {
    case 'Team':
    case 'MortgageBrokerTeam':
      return TEAM;
    case 'Agency':
    default:
      return OFFICE;
  }
}
